import React, { useState, useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import request from "helper/request";
import { Modal, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import ImportLocation from "../components/ImportLocation";
import LocationsTable from "../components/LocationsTable";
import { ImportIcon } from "components/svgs/ImportIcon";
import "./Locations.scss";
import { FilterIcon } from "components/svgs";
import LocationsFilter from "../components/filters/Locations/LocationsFilter";
import { buildFirstLevelFilterLocations } from "helper/util";

export default function Locations() {
  const history = useHistory();
  const [savedLocations, setSavedLocations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openImportModal, setOpenImportModal] = useState(false);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    total: 0
  });

  const [showFilter, setShowFilter] = useState(false);

  const getSavedLocations = useCallback(
    async (page = 1, pageSize = 10, values) => {
      setLoading(true);

      const params = {
        filter: buildFirstLevelFilterLocations(values),
        page,
        pageSize
      };
      const response = await request.get(`/saved-locations/all-locations`, {
        params
      });

      if (!response?.data) {
        return;
      }

      const { data, metadata } = response;

      setSavedLocations(data);

      setPagination((prev) => ({
        ...prev,
        current: metadata.currentPage,
        pageSize: metadata.itemsPerPage,
        total: metadata.totalItems
      }));

      setLoading(false);
    },
    [setSavedLocations, setLoading]
  );

  useEffect(() => {
    getSavedLocations(pagination.current, pagination.pageSize);
    // eslint-disable-next-line
  }, []);

  const submitFilter = (values) => {
    getSavedLocations(pagination.current, pagination.pageSize, values);
  };

  const handleAddNewLocation = () => {
    history.push("/locations/new");
  };

  return (
    <div className="Locations">
      <h2 className="title" style={{ marginBottom: "0px", fontSize: "18px" }}>
        Locations
      </h2>
      <div
        style={{
          display: "flex",
          justifyContent: "end",
          marginTop: "0px",
          marginBottom: "20px",
          gap: "8px"
        }}
      >
        <Button
          size={showFilter ? "normal" : "small"}
          className={`svg-icon ${showFilter && "filter"} d-flex flex-row`}
          onClick={() => setShowFilter(!showFilter)}
        >
          Filter <FilterIcon />
        </Button>
        <Button type="primary" icon={<PlusOutlined />} onClick={handleAddNewLocation}>
          Add New Location
        </Button>
        <Button
          className={`svg-icon  d-flex flex-row`}
          onClick={() => {
            setOpenImportModal(!openImportModal);
          }}
        >
          Import
          <ImportIcon />
        </Button>
      </div>
      {showFilter && (
        <LocationsFilter setShowFilter={setShowFilter} submitFilter={submitFilter} />
      )}

      <div id="editor">
        {openImportModal && (
          <Modal
            title={"Import Flexio Pool Data"}
            footer={false}
            width={1000}
            open={openImportModal}
            onCancel={() => {
              setOpenImportModal(!openImportModal);
            }}
          >
            <ImportLocation
              setOpenImportModal={setOpenImportModal}
              getSavedLocations={getSavedLocations}
            />
          </Modal>
        )}
        <LocationsTable
          dataSource={savedLocations}
          loading={loading}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            showSizeChanger: true,
            onChange: (page, pageSize) => {
              getSavedLocations(page, pageSize);
            },
            onShowSizeChange: (_, size) => {
              getSavedLocations(1, size);
            }
          }}
        />
      </div>
    </div>
  );
}
